import { Toast } from "components";
import { UPDATE_REFRESH_TIMER_IN_SEC } from "config/constants";
import { memo, useEffect, useState } from "react";

const VersionUpdatedToast = ({ showUpdateAlert, updateAlertClose }) => {
    const [updateTimer, setUpdateTimer] = useState(UPDATE_REFRESH_TIMER_IN_SEC);

    useEffect(() => {
        if (showUpdateAlert) {
            setUpdateTimer(UPDATE_REFRESH_TIMER_IN_SEC);
            startUpdateTimer();
        }
    }, [showUpdateAlert]);

    const startUpdateTimer = () => {
        let myInterval = setInterval(() => {
            if (updateTimer > 0) {
                setUpdateTimer((prevupdateTimer) => {
                    if (prevupdateTimer <= 1) {
                        updateAlertClose();
                        clearInterval(myInterval);
                    }
                    return prevupdateTimer - 1;
                });
            }
        }, 1000);
    };

    return (
        <Toast
            show={showUpdateAlert}
            style={{ position: "absolute", bottom: "10px", right: "10px" }}
        >
            <Toast.Body>
                {`New update available, browser will be reloaded in ${updateTimer}`}
            </Toast.Body>
        </Toast>
    );
};
export default memo(VersionUpdatedToast);
